module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"","searchOnlyApiKey":"","indexName":""}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/search.json
// module id = 739
// module chunks = 254572558124955